import { useMemo } from 'react';
import { IFeaturesConfig } from '../../../../../interface/interfaces';
import { useAppSelector } from '../../../../../redux/hooks';
import { rootState } from '../../../../../redux/store';
import { mappingLdapToInFlowFeatures } from '../../../../../utils/mapping';

const useFeaturesFilterData = (featuresData: IFeaturesConfig[], isChecked: boolean) => {
    const { userAndTokenData } = useAppSelector((state: rootState) => state.loginUserAndTokenData);

    // Memoizacija filtriranja podataka
    const featuresDataFilter = useMemo(() => {
        if (!Array.isArray(featuresData)) {
            return [];
        }

        return featuresData.filter((filterItem: IFeaturesConfig) => {
            // match LDAP user department with features
            return isChecked ? filterItem.DepartmentName === mappingLdapToInFlowFeatures(userAndTokenData?.user.department || '') : true;
        });
    }, [featuresData, isChecked, userAndTokenData]);

    // Provera validnosti podataka
    const isValid = Array.isArray(featuresData);

    // Vraćanje podataka
    return { featuresDataFilter, isValid, error: isValid ? null : String(featuresData) };
};

export default useFeaturesFilterData;
